<breadcrumb-navigation [titles]="[{ key: 'CART_TERMS', url: ''}]"></breadcrumb-navigation>

<div class="user-terms">
    <div>
        <div class="top-title sm:px-4 sm:text-2xl sm:items-baseline">欢迎进入博世智能交通售后配件自助订购平台!</div>
        <!-- <div class="top-tip sm:px-4 sm:text-lg" >Data Protection Policy of Bosch Automotive Aftermarket (China) Co. Ltd.</div> -->
    </div>
    <div class="px-4 py-8 sm:p-4">
        <!-- <h3 class="title sm:text-2xl">博世智能出行售后经销商门户</h3> -->
        <p class="pb-8">
            为了更好的服务客户，提高订单满足率和客户满意度，以下订单管理条款条件将作为博世汽车技术服务（中国）有限公司（以下简称“博世”）与经销商就客户订单在博世智能交通售后配件自助订购平台（以下简称“本系统”）中生成有效执行的协议。本协议是对于双方具有约束力的法律文件，请认真阅读并遵守该协议，充分理解条款内容。在贵公司接受本协议后，方可建立客户订单。
        </p>
        <ul class="A-List A-List--unordered">
            <span
                class="A-List__itemText">(1)经销商在本系统上提交客户订单时，应当确认所需料号，数量，不含税单项价格，需求日期，收货地址等信息，提交订单即视为客户确认该订单，提交订单的日期即为下单日期。具体订单数据以博世订单系统记录为准，如经销商对系统数据有异议的，需提供相应凭证，双方核对后确定订单信息。在博世收到客户订单且确认相关信息后，该客户订单生效。双方同意本协议项下任一已通过确认的客户订单为本协议不可分割的一部分。
            </span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span
                class="A-List__itemText">(2)鉴于客户订单的合理性和有效性以及博世报价的时限性，博世仅接受经销商需求日期在下单日期起十二个月内的客户订单。例如：下单日期为2020年01月01日，需求日期最远为2020年12月31日。
            </span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span
                class="A-List__itemText">(3)对于小于正常交货期的客户订单，博世有权按照事先公布的正常交货期供货，并在客户订单生成前，系统会提示经销商相应的博世交货期，经销商可选择按此博世交货期完成下单，如经销商未点击确认下单，视为经销商放弃下单。
            </span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span
                class="A-List__itemText">(4)在客户订单上载明的博世产品数量明显高于博世正常备货水平和供货能力的情况下，为了减少交货延期和客户损失，双方应当积极沟通解决方案，友好协商，并再次确认后该客户订单方生效。
            </span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span
                class="A-List__itemText">(5)在博世正常到货的情况下 ，经销商应当按照提单（提单即为发货通知单）创建顺序提货。 如果由于博世单方面原因造成生效客户订单的延期交货，经销商有权与博世协商后修改提货计划。
            </span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span class="A-List__itemText">(6)经销商基于订单库存创建提单后，若提单金额超出本公司授予的信用额度，则须在提单创建之日起的<span style="color: red;">7</span>个工作日内完成付款。逾期未付款的，将取消该提单以及对应的订单。博世对此流程拥有最终解释权，且无需承担任何违约责任。
            </span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span class="A-List__itemText">(7)博世的“交货的一般条款与条件”为生效的客户订单的附件，与本协议和生效的客户订单具有同等法律效力。<span style="color: red; text-decoration: underline;">如两者冲突的，以本协议为准。博世将于届时双方约定的地址交货于经销商，博世不负责卸货。产品的所有权及风险在博世交付时转移至经销商。但产品的知识产权始终归博世。</span></span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span class="A-List__itemText">
                (8)双方确认依据本协议下达的客户订单的履约条款需遵循本协议约定标准，客户订单仅为履行本协议下达采购明细的文件，如客户订单约定超出本协议约定原则的，双方需另行协商达成补充协议，如客户订单约定与本协议冲突的，以本协议约定为准。</span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span class="A-List__itemText">
                (9)自合同签订之日起，如发生以下情形：1)劳动力、原材料成本上涨幅度超过 5%；2)与成本相关的可追溯技术规范或其他服务要求发生变更；3) 生产成本、市场行情发生重大变化，博世可启动价格调整协商。博世应向客户发出书面调价通知，双方应于收到该通知后30 日内就新价格磋商并达成一致，新价格须经客户书面确认后方可生效；若达成一致，调整后的新价格于博世发出书面调价通知后的第 60 日起执行。若双方在前述 30 日期限内未能就调价达成共识，任何一方有权终止合同。</span>
        </ul>
        <ul class="A-List A-List--unordered">
            <span class="A-List__itemText">
                (10)双方已仔细阅读本协议，并完全理解、接受本协议的全部内容、条款和修定。博世汽车技术服务（中国）有限公司对该协议具有最终解释权。<span style="color: red; text-decoration: underline;">如果没有更新版本，此份协议永久有效。</span></span>
        </ul>
        <!-- <div class="A-List A-List--unordered">
      <p>8. 双方确认依据本协议下达的客户订单的履约条款需遵循本协议约定标准，客户订单仅为履行本协议下达采购明细的文件，如客户订单约定超出本协议约定原则的，双方需另行协商达成补充协议，如客户订单约定与本协议冲突的，以本协议约定为准。</p>
    </div> -->
        <!-- <ul class="A-List A-List--unordered">
            <span
                class="A-List__itemText">(10)双方已仔细阅读本协议，并完全理解、接受本协议的全部内容、条款和修定。博世汽车技术服务（中国）有限公司上海分公司对该协议具有最终解释权。如果没有更新版本，此份协议永久有效。</span>
        </ul> -->
        <ul class="A-List A-List--unordered">
            <span class="A-List__itemText">如果您对本协议有疑问，请联系博世客户服务部400-000-5109*2</span>
            <br>
            <span class="A-List__itemText">非常感谢您的支持和配合！</span>
        </ul>
    </div>
</div>
